// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { CrossRateData } from "../../../../Utils/CrossRate/CrossRateData.js";
import { DirectCrossRateMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
export let CrossRateMessageProcessor = function (parentDecoder)
{
    MessageProcessorBase.call(this)
    this.decoder = parentDecoder
}

CrossRateMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

CrossRateMessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory
    let AssetDecodeMap = this.decoder.AssetDecodeMap

    let crossRateGroups = fieldSet.GetGroups(factory.CROSS_GROUP)
    let len = crossRateGroups.length
    let res = []

    for (let i = 0; i < len; i++)
    {
        let crg = crossRateGroups[i]
        let crd = new CrossRateData()
        res.push(crd)

        let asset2Id = crg.GetValue(factory.FIELD_ASSET_ID2)
        if (asset2Id === null)
        {
            crd.Exp1 = crg.GetValue(factory.FIELD_NAME_EXP1)
            crd.Exp2 = crg.GetValue(factory.FIELD_NAME_EXP2)
        } else
        {
            // новая схема, когда вместо строки передается ID
            let asset1Id = crg.GetValue(factory.FIELD_ASSET_ID)
            crd.Exp1 = AssetDecodeMap[asset1Id] || null
            crd.Exp2 = AssetDecodeMap[asset2Id] || null
        }

        crd.Price = crg.GetValue(factory.FIELD_PRICE)
    }

    return [new DirectCrossRateMessage(res)]
}
